import AdminDashboard from '@/admin/pages/Dashboard'
import PublisherList from '@/admin/pages/PublisherList'
import DemandPartners from '@/admin/pages/DemandPartners'
import PublisherSettings from '@/publisher/pages/PublisherSettings'
import Explorer from '@/reports/pages/Explorer/Explorer'
import Activity from '@/reports/pages/Activity'
import User from '@/reports/pages/User'
import AdReview from '@/reports/pages/AdReview'
import AdDetails from '@/reports/pages/AdDetails'
import DemandSettings from '@/demand/pages/Settings'
import CompanySettings from "@/company/pages/CompanySettings"
import CompanyList from "@/admin/pages/CompanyList"
import CompanyProfile from "@/company/pages/CompanyProfile"
import Account from '@/accounts/pages/Account'
import ExchangeList from "@/admin/pages/ExchangeList"
import ExchangeSettings from "@/exchange/pages/ExchangeSettings"
import ScanTabs from "@/demand/pages/ScanTabs"
import AdApprovals from "./pages/AdApprovals"
import GlobalConfig from "./pages/GlobalConfig"
import PublicDeals from '@/demand/pages/Deals'
import AdminNodes from '@/admin/pages/Nodes'
import dealSettings from "../demand/pages/DealSettings.vue";
import DealSettings from "../demand/pages/DealSettings.vue";
import DealTargeting from "../demand/pages/DealTargeting.vue";
import ThrottleStats from "../demand/pages/ThrottleStats.vue";
import InspectionList from "./pages/InspectionList.vue";
import InspectionSettings from "./pages/InspectionSettings.vue";
import InspectionResults from "./pages/InspectionResults.vue";

export default [
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      permissions: ['ADMIN'],
    }
  },
  {
    path: '/admin/nodes',
    name: 'AdminNodes',
    component: AdminNodes,
    meta: {
      permissions: ['ADMIN'],
    }
  },
  {
    path: '/admin/companies/create',
    name: 'AdminCompanyCreate',
    component: CompanySettings,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Companies', to: {name: 'AdminCompanies'}},
        {name: 'Create', to: {name: 'AdminCompanyCreate'}}
      ]
    },
  },
  {
    path: '/admin/companies',
    name: 'AdminCompanies',
    component: CompanyList,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Companies', to: {name: 'AdminCompanies'}}
      ]
    },
  },
  {
    path: '/admin/companies/:cid',
    name: 'AdminCompanyProfile',
    component: CompanyProfile,
    props: true,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Companies', to: {name: 'AdminCompanies'}},
        {name: ':cid', to: {name: 'AdminCompanyProfile', params: ['cid']}}
      ]
    }
  },
  {
    path: '/admin/companies/:cid/account/:uid',
    name: 'AdminAccountEdit',
    component: Account,
    props: true,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Companies', to: {name: 'AdminCompanies'}},
        {name: ':cid', to: {name: 'AdminCompanyProfile', params: ['cid']}},
        {name: 'User', to: {name: 'AdminAccountEdit', params: ['cid', 'uid']}}
      ]
    }
  },
  {
    path: '/admin/publishers',
    name: 'AdminPublisherList',
    component: PublisherList,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Publishers', to: {name: 'PublisherList'}}
      ]
    }
  },
  {
    path: '/admin/publishers',
    name: 'AdminPublisherSettings',
    component: PublisherSettings,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Publishers', to: {name: 'Publishers'}},
        {name: 'Settings', to: {name: 'AdminPublisherSettings', params: [ 'cid' ] }}
      ]
    }
  },
  {
    path: '/admin/bidders',
    name: 'AdminDemandPartners',
    component: DemandPartners,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Bidders', to: {name: 'AdminDemandPartners'}}
      ]
    }
  },
  {
    path: '/admin/bidders/:cid',
    name: 'AdminDemandSettings',
    component: DemandSettings,
    props: true,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Bidders', to: {name: 'AdminDemandPartners'}},
        {name: ':cid', to: {name: 'AdminDemandSettings', params: ['cid']}}
      ]
    }
  },
  {
    path: '/admin/exchanges',
    name: 'AdminExchangeList',
    component: ExchangeList,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Exchanges', to: {name: 'AdminExchangeList'}}
      ]
    }
  },
  {
    path: '/admin/exchange/:cid',
    name: 'AdminExchangeSettings',
    component: ExchangeSettings,
    props: true,
    meta: {
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Exchanges', to: {name: 'AdminExchangeList'}},
        {name: ':cid', to: {name: 'AdminExchangeSettings', params: ['cid']}}
      ]
    }
  },
  {
    path: 'demand/new',
    name: 'NewDemand',
    component: DemandSettings,
    meta: {
      title: 'New Partner',
      permissions: ['ADMIN'],
      breadcrumbs: {
        ADMIN: [
          {name: 'Partners', to: {name: 'Demand'}},
          {name: 'New Partner'}
        ]
      }
    }
  },
  {
    path: '/admin/reports/explorer',
    name: 'AdminExplorer',
    component: Explorer,
    meta: {
      title: 'Inventory Analytics',
      permissions: ['ADMIN'],
      breadcrumbs: [
        {name: 'Explorer'}
      ]
    }
  },
  {
    path: '/admin/reports/activity',
    name: 'AdminActivity',
    component: Activity,
    meta: {
      title: 'Activity',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Activity' }
      ]
    }
  },
  {
    path: '/admin/creatives/review',
    name: 'AdminAdReview',
    component: AdReview,
    meta: {
      title: 'Ad Review',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Live Ad Review' }
      ]
    }
  },
  {
    path: '/reports/review/details/:partnerId/:cid/:crid',
    name: 'AdminAdDetails',
    component: AdDetails,
    props: true,
    meta: {
      title: 'Ad Details',
      permissions: ['ADMIN'],
      breadcrumbs: {
        ADMIN: [
          {name: 'Ad Review', to: {name: 'AdminAdReview'}},
          {name: 'Ad Details'}
        ],
      }
    }
  },
  {
    name: 'AdminScanTabs',
    path: '/admin/scans',
    component: ScanTabs,
    meta: {
      title: 'TMT Scan Activity',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Ad Scanning' }
      ]
    }
  },
  {
    name: 'AdminAdApprovals',
    path: '/admin/approvals',
    component: AdApprovals,
    meta: {
      title: 'Creative Approvals',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Approvals' }
      ]
    }
  },
  {
    name: 'AdminGlobalConfig',
    path: '/admin/config',
    component: GlobalConfig,
    meta: {
      title: 'Market Pixel Settings',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Pixel' }
      ]
    }
  },
  {
    name: 'AdminPublicDeals',
    path: '/admin/deals',
    component: PublicDeals,
    meta: {
      title: 'Market Deals',
      permissions: ['ADMIN'],
      breadcrumbs: [
        { name: 'Deals' }
      ]
    }
  },
  {
    name: 'AdminDealSettings',
    path: '/admin/deal/:dealid?',
    component: DealSettings,
    props: true
  },
  {
    name: 'AdminDealTargeting',
    path: '/admin/deal/targeting/:dealid/:targetingidx?',
    component: DealTargeting,
    props: true
  },
  {
    name: 'AdminInspections',
    path: '/admin/inspections',
    component: InspectionList
  },
  {
    name: 'AdminInspection',
    path: '/admin/inspection/:id?',
    component: InspectionSettings,
    props: true
  },
  {
    name: 'AdminInspectionResults',
    path: '/admin/inspection/results/:id',
    component: InspectionResults,
    props: true
  },
  {
    path: '/demand/throttle/:cid/:epid',
    name: 'ThrottleStats',
    component: ThrottleStats,
    props: true,
    meta: {
      title: 'Throttle Stats',
      breadcrumbs: [
        {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
        {name: 'Bidder Throttle Stats'}
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/admin/routes.js